import $ from 'jquery';
export const expander = function (){


	function itemWidth() {
		let item_width = $('.cp-Expander_Panel').not(['.js-Active', ':hover']).width();
		if ($(window).width() <= 800) {
			item_width = 200;
		}
		return item_width;
	}

	function itemCount() {
		let items = $('.cp-Expander_Panel');
		let items_count = items.length;
		return items_count;
	}

	function activeWidths() {
		let infobox_width = 700;
		let inactive_item_width = 100;

		if ($(window).width() <= 800) {
			infobox_width = 500;
			inactive_item_width = 80;
		}

		$('.cp-Expander_Panel.js-Active').css({
			width: infobox_width
		})
		$('.cp-Expander_Panel:not(.js-Active)').css({
			width: inactive_item_width
		})
		wrapWidth();

	}

	$('.cp-Expander_Panel').on('click', function(){
		if ($(this).hasClass('js-Active')) {
			$(this).removeClass('js-Active');
		} else {
			$('.cp-Expander_Panel.js-Active').removeClass('js-Active');
			$(this).addClass('js-Active');
		}
	});


	$('.cp-Expander_NavButton-left').on('click', function() {
		let prev = prevPanels().pop();
		if (prev != undefined) {
			$('.cp-Expander_Inner').animate({
				scrollLeft : prev.offsetLeft
			}, 300, 'swing')
			setTimeout(() => checkArrows(), 300)
		}
	});

	$('.cp-Expander_NavButton-right').on('click', function() {
		let next = nextPanels();
		if (next.length) {
			$('.cp-Expander_Inner').animate({
				scrollLeft : next[0].offsetLeft + next[0].offsetWidth - $('.cp-Expander').width()
			}, 300, 'swing')
			setTimeout(() => checkArrows(), 300)
		}
	});

	function nextPanels() {
		const panels = Array.prototype.slice.call(document.querySelectorAll('.cp-Expander_Panel'))
		let nextPanels = panels.filter(function(el, index, arr) {
			return el.offsetLeft - $('.cp-Expander_Inner').scrollLeft() >= $('.cp-Expander').width()
		});
		return nextPanels;
	}
	function prevPanels() {
		const panels = Array.prototype.slice.call(document.querySelectorAll('.cp-Expander_Panel'))
		let prevPanels = panels.filter(function(el, index, arr) {
			return el.offsetLeft + el.offsetWidth <= $('.cp-Expander_Inner').scrollLeft()
		});
		return prevPanels;
	}

	function checkArrows() {
		// console.log('prevPanels().length ' , prevPanels().length);
		if (prevPanels().length) {
			$('.cp-Expander_NavButton-left').removeClass('inactive');
		} else {
			$('.cp-Expander_NavButton-left').addClass('inactive');
		}

		// console.log('nextPanels().length ' , nextPanels().length);
		if (nextPanels().length) {
			$('.cp-Expander_NavButton-right').removeClass('inactive');
		} else {
			$('.cp-Expander_NavButton-right').addClass('inactive');
		}
	}
	checkArrows();
}








